import { NavigateFunction } from "react-router-dom";
import { Video } from "../api/interfaces/Video";

export const watchVideoRedirect = (navigate: NavigateFunction, video: Partial<Video>, playable: boolean) => {
    if (playable) {
        if (video.videoUrl?.trim() && video.videoUrl1?.trim() || video.videoUrl2?.trim()) {
            navigate(`/select/player/${video._id}`);
        } else if (video.videoUrl?.trim() && !video.videoUrl1?.trim() && !video.videoUrl2?.trim()) {
            navigate(`/watch/player1/${video._id}`);
        } else if (!video.videoUrl?.trim() && video.videoUrl1?.trim() && !video.videoUrl2?.trim()) {
            navigate(`/watch/player2/${video._id}`);
        } else if (!video.videoUrl?.trim() && !video.videoUrl1?.trim() && video.videoUrl2?.trim()) {
            navigate(`/watch/player3/${video._id}`);
        }
    }
}